<template>
  <section ref="root" class="dc-container">
    <!-- Papel rasgado superior mantenido en la estructura -->
    <div class="rasgado rasgado-top"></div>

    <!-- 🌟 CAPA DE FONDO SATINADO Y ONDA DE LUZ RESPLANDECIENTE -->
    <div class="onda-luz-bg"></div>

    <!-- ELEMENTOS DECORATIVOS PREMIUM (TELAS Y FLORES DE LA IMAGEN) -->
    <img src="@/assets/brillo.avif" class="adorno-satin-top" alt="" />
    <img src="@/assets/petalos.png" class="flor-decorativa flor-top-right" alt="" />
    <img src="@/assets/petalos.png" class="flor-decorativa flor-bottom-left" alt="" />
    <img src="@/assets/brillo.avif" class="adorno-satin-bottom-right" alt="" />

    <!-- CONTENIDO EDITORIAL LUXURY -->
    <div class="dc-card">
      
      <!-- 🌟 TÍTULO EDITORIAL CON ESTILO "DRESS CODE" EN DOS LÍNEAS -->
      <h2 ref="title" class="dc-title"><br /><br /><br /><br /><br /><br />
        <span class="serif-title">Dress</span><br />
        <span class="script-title">Code<br /><br /></span>
      </h2>

      <!-- 🌟 ILUSTRACIÓN DE VESTIMENTA (TRAJE Y VESTIDO DE LA IMAGEN) -->
      <img
        ref="figure"
        src="@/assets/codigo1.avif"
        alt="Dress Code"
        class="dc-figure"
      />
<br />
      <!-- 🌟 ETIQUETA / BADGE CON TIPOGRAFÍA SERIF REFINADA -->
      <div ref="badge" class="dc-badge">FORMAL</div>

      <!-- 🌟 NOTA EXCLUSIVA EN INGLÉS ANIMADA PALABRA POR PALABRA -->
      <p ref="note" class="dc-note">
      Colores exclusivos de la Quinceañera, evita los siguientes tonos:
      </p>

      <!-- 🌟 PALETA DE COLORES RESERVADOS -->
      <img
        ref="palette"
        src="@/assets/paletacolores.png"
        alt="Paleta de Colores Reservados"
        class="dc-palette"
      />

      <!-- 🌟 NOTA PARA ADOLESCENTES -->
      <p ref="teenNote" class="dc-teen-note">
        <span class="teen-highlight">Adolescentes:</span> Vestir color negro.
      </p>

      <br /><br /><br />
    </div>

    <!-- Papel rasgado inferior mantenido en la estructura -->
    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const palette = ref(null)
    const teenNote = ref(null)

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      // Formateo de palabra por palabra para la nota principal
      let wordSpans = null
      if (note.value) {
        const words = note.value.innerText.trim().split(/\s+/)
        note.value.innerHTML = words
          .map(word => `<span class="word" style="display: inline-block;">${word}</span>`)
          .join(' ')
        wordSpans = note.value.querySelectorAll('.word')
      }

      // Línea de tiempo principal sincronizada con el viewport
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 72%', 
          toggleActions: 'play none none reverse'
        }
      })

      /* ENTRADA DE ELEMENTOS DECORATIVOS */
      tl.fromTo('.flor-decorativa, .adorno-satin-top, .adorno-satin-bottom-right', 
        { opacity: 0, scale: 0.8 },
        { opacity: 1, scale: 1, duration: 1, ease: 'power2.out' }
      )

      /* ENTRADA CINEMATOGRÁFICA DEL TÍTULO */
      tl.fromTo(title.value, 
        { opacity: 0, y: -45, filter: 'blur(10px)' },
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.8, ease: 'power3.out' },
        '-=0.6'
      )

      /* APARICIÓN DE LAS ILUSTRACIONES DE VESTIMENTA */
      if (figure.value) {
        tl.fromTo(figure.value,
          { opacity: 0, scale: 0.75, y: 35 },
          { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: 'back.out(1.4)' },
          '-=0.5'
        )
      }

      /* REVELADO ELEGANTE DEL TEXTO FORMAL */
      if (badge.value) {
        tl.fromTo(badge.value,
          { opacity: 0, y: 30, scale: 0.92 },
          { opacity: 1, y: 0, scale: 1, duration: 0.6, ease: 'power3.out' },
          '-=0.4'
        )
      }

      /* ANIMACIÓN PALABRA POR PALABRA DE LA NOTA */
      if (wordSpans && wordSpans.length) {
        tl.fromTo(wordSpans,
          { opacity: 0, y: 15, filter: 'blur(4px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.4, ease: 'power2.out', stagger: 0.06 },
          '-=0.3'
        )
      }

      /* ENTRADA DE LA PALETA DE COLORES */
      if (palette.value) {
        tl.fromTo(palette.value,
          { opacity: 0, scale: 0.85, y: 20 },
          { opacity: 1, scale: 1, y: 0, duration: 0.7, ease: 'back.out(1.2)' },
          '-=0.2'
        )
      }

      /* ENTRADA DE LA NOTA PARA ADOLESCENTES */
      if (teenNote.value) {
        tl.fromTo(teenNote.value,
          { opacity: 0, y: 20, filter: 'blur(4px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.6, ease: 'power3.out' },
          '-=0.3'
        )
      }
    })

    onUnmounted(() => {
      const triggers = ScrollTrigger.getAll()
      triggers.forEach(trigger => {
        if (trigger.vars.trigger === root.value) trigger.kill()
      })
    })

    return { root, title, badge, figure, note, palette, teenNote }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&family=Montserrat:wght@300;400;500&family=Great+Vibes&display=swap');

.dc-container {
  position: relative;
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  background:
    linear-gradient(
      rgba(255, 255, 255, 0.85),
      rgba(255, 255, 255, 0.45)
    ),
    url('@/assets/codigo.jpg') center center / cover no-repeat;
  overflow: visible;
  text-align: center;
  box-sizing: border-box;
}

/* 🌟 EFECTO DE RESPLANDOR / ONDA DE LUZ VERTICAL RECTALÍNEA EN EL FONDO */
.onda-luz-bg {
  position: absolute;
  top: 0;
  left: -50%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 46%,
    rgba(255, 255, 255, 0.75) 50%,
    rgba(255, 255, 255, 0) 54%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 1;
  animation: barridoLuzVertical 6s infinite linear;
  pointer-events: none;
}

@keyframes barridoLuzVertical {
  0% { transform: translateX(-30%); }
  100% { transform: translateX(80%); }
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background:
    linear-gradient(
      rgba(146, 159, 132, 0.541),
      rgba(243, 231, 230, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  z-index: 4;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  background:
    linear-gradient(
      rgba(146, 159, 132, 0.541),
      rgba(243, 231, 230, 0.705)
    ),
    url('@/assets/fn.avif') center center / cover no-repeat;
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 3;
}

/* 🌟 SECCIÓN DE CABECERA EDITORIAL (DRESS CODE) */
.dc-title {
  margin: 0 auto 28px;
  line-height: 0.85;
}

.serif-title {
  font-family: 'british', serif;
  font-weight: 400;
  font-size: clamp(36px, 12vw, 36px);
  color: #73896a;
  line-height: 1.8; /* Recomendado: escala automáticamente */
  letter-spacing: 0.15em;
  display: inline-block;
}

.script-title {
  font-family: 'british', cursive;
  font-weight: 400;
  font-size: clamp(36px, 12vw, 36px);
  color: #73896a;
  margin-top:10px;
  letter-spacing: 0.15em;
  display: inline-block;
}

/* 🌟 ILUSTRACIÓN DE TRAJE Y VESTIDO DE LA IMAGEN */
.dc-figure {
  width: min(85%, 260px);
  margin: 0 auto 24px;
  display: block;
  margin-top:15px;
  object-fit: contain;
  filter: drop-shadow(0 6px 15px rgba(225, 180, 185, 0.2));
}

/* 🌟 ETIQUETA / BADGE CON TIPOGRAFÍA SERIF REFINADA */
.dc-badge {
  display: inline-block;
  font-family: 'bethany', serif;
  font-weight: 400;
  font-size: clamp(26px, 6vw, 32px);
  color: #a0aa9a;
  letter-spacing: 0.12em;
  margin: 0 auto 16px;
  text-transform: uppercase;
}

/* 🌟 TEXTO DE NOTA EXCLUSIVA */
.dc-note {
  font-family: 'bethany', sans-serif;
  font-size: clamp(17px, 3.5vw, 16px);
  color: #2c2c2c;
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;
  margin: 0 auto 16px;
  max-width: 85%;
  letter-spacing: 0.02em;
}

/* 🌟 PALETA DE COLORES */
.dc-palette {
  width: min(80%, 280px);
  margin: 12px auto 20px;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.05));
}

/* 🌟 NOTA ADOLESCENTES */
.dc-teen-note {
  font-family: 'bethany', sans-serif;
  font-size: clamp(16px, 3.2vw, 18px);
  color: #2c2c2c;
  font-weight: 400;
  line-height: 1.5;
  margin: 10px auto 0;
  max-width: 85%;
  letter-spacing: 0.02em;
}

.teen-highlight {
  font-weight: 600;
  color: #4a4a4a;
}

/* spans del texto animado */
.word {
  display: inline-block;
  white-space: nowrap;
}

/* 🌟 ELEMENTOS GRÁFICOS COMPLEMENTARIOS */
.flor-decorativa, [class^="adorno-satin"] {
  position: absolute;
  pointer-events: none;
  object-fit: contain;
  z-index: 2;
}

.adorno-satin-top {
  top: -90px;
  left: -50px;
  width: 320px;
  z-index: 10;
  opacity: 0.9;
}

.flor-top-right {
  top: 15px;
  right: -65px;
  width: 160px !important;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.06));
}

.flor-bottom-left {
  bottom: 120px !important;
  left: -95px;
  width: 160px !important;
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.06));
}

.adorno-satin-bottom-right {
  top: 260px;
  right: -350px;
  width: 560px;
  transform: rotate(90deg);
  opacity: 0.85;
}
</style>